import * as types from '../actionType';

let initState = [
  {
    Id: 1,
    Name: '',
    Status: 0,
  },
];

function ExamTypeState(state = initState, action) {
  switch (action.type) {
    case types.EXAM_TYPE_LIST_SUCCESS: {
      return action.result;
    }
    default:
      return state;
  }
}

export default ExamTypeState;
